import { useDispatch, useSelector } from 'react-redux';
import React, { useState, createRef, useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import {
  SideMenu,
  RichTextSection,
} from 'design-comuni-plone-theme/components/ItaliaTheme/View';
import { Card, Label, Input, TextArea } from 'design-react-kit';
import { changeBookingField } from '@redturtle/volto-io-prenoto/helpers/prenotazione';
import { PrenotazioneStepperActions } from '@redturtle/volto-io-prenoto/components/View/PrenotazioneView';
import { InputFieldsSchema } from '@redturtle/volto-io-prenoto/components/View/Commons';
import {
  checkValidEmail,
  checkValidCF,
} from '@redturtle/volto-io-prenoto/helpers';

const messages = defineMessages({
  request_title: {
    id: 'booking_request_title',
    defaultMessage: 'Richiedente',
  },
});

const PrenotazioneRichiedente = ({
  prenotazioneObj,
  setPrenotazioneObj,
  activeStep,
  setActiveStep,
  scrollToTop,
}) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  // SIDEMENU
  let documentBody = createRef();
  const [sideMenuElements, setSideMenuElements] = useState(null);

  useEffect(() => {
    if (documentBody.current) {
      if (__CLIENT__) {
        setSideMenuElements(documentBody.current);
      }
    }
  }, [documentBody]);

  /* check if input fields are required and populated */
  const checkRequiredValue = () => {
    let check = [];
    if (prenotazioneObj.booking_schema.length > 0) {
      check = prenotazioneObj.booking_schema.filter((field) => {
        const value =
          prenotazioneObj.booking_fields.filter(
            (f) => f.name === field.name,
          )?.[0]?.value ?? '';
        return field.name === 'email'
          ? field.required && (value === '' || checkValidEmail(value) === false)
          : field.name === 'fiscalcode'
            ? field.required && (value === '' || checkValidCF(value) === false)
            : field.required && value === '';
      });
    }
    return check.length > 0;
  };

  const getFieldValue = (field) => {
    return (
      prenotazioneObj.booking_fields.filter((f) => f.name === field)?.[0]
        ?.value ?? ''
    );
  };

  const changeField = (name, value) => {
    setPrenotazioneObj({
      ...prenotazioneObj,
      booking_fields: changeBookingField(
        prenotazioneObj.booking_fields,
        name,
        value,
      ),
    });
  };

  return (
    <>
      {/* MENU LATERALE */}
      <aside aria-hidden={true} className="col-12 col-lg-3">
        {__CLIENT__ && (
          <SideMenu
            data={sideMenuElements}
            content_uid={'prenotazioneRichiedente'}
          />
        )}
      </aside>
      <section
        id="main-content-section"
        className="prenotazioneRichiedente section-form col-12 col-lg-8 offset-lg-1 mt-3"
        ref={documentBody}
      >
        <RichTextSection
          title={intl.formatMessage(messages.request_title)}
          tag_id="prenotazioneRichiedente_section"
          show_title={false}
        >
          <Card className="section-form--card mb-0 no-after">
            {/* FORM RICHIEDENTE */}
            <h2 className="mb-5" aria-hidden={true}>
              {intl.formatMessage(messages.request_title)}
            </h2>
            <div className="bg-white px-3 pt-5 mb-0">
              <InputFieldsSchema
                schema={prenotazioneObj.booking_schema}
                getFieldValue={getFieldValue}
                changeField={changeField}
              />
            </div>
          </Card>
        </RichTextSection>
      </section>

      {/* BUTTONS */}
      <PrenotazioneStepperActions
        activeStep={activeStep}
        setActiveStep={setActiveStep}
        disabled={checkRequiredValue()}
        scrollToTop={scrollToTop}
      />
    </>
  );
};

export default PrenotazioneRichiedente;
